var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70741 2.29292C3.5188 2.11076 3.2662 2.00997 3.00401 2.01224C2.74181 2.01452 2.491 2.11969 2.30559 2.3051C2.12018 2.49051 2.01501 2.74132 2.01273 3.00352C2.01045 3.26571 2.11125 3.51832 2.29341 3.70692L16.2934 17.7069C16.482 17.8891 16.7346 17.9899 16.9968 17.9876C17.259 17.9853 17.5098 17.8801 17.6952 17.6947C17.8806 17.5093 17.9858 17.2585 17.9881 16.9963C17.9904 16.7341 17.8896 16.4815 17.7074 16.2929L16.2344 14.8199C17.7919 13.578 18.9437 11.8998 19.5424 9.99992C18.2684 5.94292 14.4784 2.99992 10.0004 2.99992C8.43284 2.99779 6.88691 3.36577 5.48841 4.07392L3.70841 2.29292H3.70741ZM7.96841 6.55292L9.48241 8.06792C9.8215 7.97787 10.1783 7.97847 10.5171 8.06965C10.8559 8.16083 11.1648 8.3394 11.4128 8.58748C11.6609 8.83557 11.8395 9.14446 11.9307 9.48325C12.0219 9.82204 12.0225 10.1788 11.9324 10.5179L13.4464 12.0319C13.8974 11.2679 14.0816 10.3757 13.9701 9.49559C13.8585 8.61548 13.4575 7.79741 12.8302 7.1701C12.2029 6.54278 11.3848 6.14181 10.5047 6.03027C9.62461 5.91872 8.73239 6.10293 7.96841 6.55392V6.55292Z",
    fill: "#ADADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.454 16.6969L9.75001 13.9919C8.77769 13.931 7.86103 13.5173 7.17206 12.8285C6.4831 12.1397 6.06918 11.2232 6.00801 10.2509L2.33501 6.57788C1.49022 7.5839 0.852357 8.7468 0.458008 9.99988C1.73201 14.0569 5.52301 16.9999 10 16.9999C10.847 16.9999 11.669 16.8949 12.454 16.6969Z",
    fill: "#ADADAD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/EyeOff.02b2aef4f6e3d92fa9bf1325112fe234.svg";
export { ForwardRef as ReactComponent };